const sortingIcon =
  '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M5.66675 8.33334L7.83341 10.5L10.0001 8.33334" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M7.83325 10.5V5.16666" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M2 3.66667L4.16667 1.5L6.33333 3.66667" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M4.16675 1.5V6.83333" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';

const sortingAscIcon =
  '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M5.66675 8.33334L7.83341 10.5L10.0001 8.33334" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M7.83325 10.5V5.16666" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M2 3.66667L4.16667 1.5L6.33333 3.66667" stroke="#1F4D7A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M4.16675 1.5V6.83333" stroke="#1F4D7A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';
const sortingDescIcon =
  '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M5.66675 8.33334L7.83341 10.5L10.0001 8.33334" stroke="#1F4D7A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M7.83325 10.5V5.16666" stroke="#1F4D7A" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M2 3.66667L4.16667 1.5L6.33333 3.66667" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M4.16675 1.5V6.83333" stroke="#A3B2C2" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';

export { sortingIcon, sortingDescIcon, sortingAscIcon };
